import { CardProps } from '@ui-system/interfaces-card';

export const actionAreaDefaultProps = {
  style: {
    flex: 1,
    flexDirection: 'row',
  },
};

const defaultProps: Partial<CardProps> = {
  style: null,
  square: false,
  elevation: 1,
};

export default defaultProps;
